import React from "react";
import { ContactInformation } from "./ContactInformation";
import { WorkInformation } from "./WorkInformation";
import { OnboardingExpectations } from "./OnboardingExpectations";
import { ContactData, WorkData, OnboardingData } from "../../../types";

interface ProfileDetailsTabProps {
  contactData: ContactData;
  workData: WorkData;
  onboardingData: OnboardingData;
  employeeId: number;
  onEditWork: () => void;
  onEditOnboarding: () => void;
}

export const ProfileDetailsTab: React.FC<ProfileDetailsTabProps> = ({
  contactData,
  workData,
  onboardingData,
  employeeId,
  onEditWork,
  onEditOnboarding,
}) => {
  return (
    <div className="flex w-full max-w-[1280px] grow shrink-0 basis-0 flex-col items-start gap-6 px-4 md:px-12 pt-6 pb-12">
      <div className="flex w-full flex-col items-start gap-4">
        <ContactInformation contact={contactData} />
        <WorkInformation work={workData} employeeId={employeeId} onEdit={onEditWork} />
        <OnboardingExpectations onboarding={onboardingData} onEdit={onEditOnboarding} />
      </div>
    </div>
  );
}; 